import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MtmAuthBridgeService } from '@mtm/auth-ui-angular';
import { REDIRECT_URI_STORAGE_KEY } from '../constants';

export const authGuestGuard: CanActivateFn = (_route, state) => {
  const bridge = inject(MtmAuthBridgeService);
  const router = inject(Router);

  if (bridge.isAuthenticated()) {
    return true;
  }
  const redirectUri = new URL(state.url, window.location.origin).href;
  // Also stash it: the query param is dropped by the SSO hops that follow, so
  // `redirectAfterAuthentication()` reads it back from here after login.
  sessionStorage.setItem(REDIRECT_URI_STORAGE_KEY, redirectUri);
  return router.createUrlTree(['/entry/login'], {
    queryParams: { redirect_uri: redirectUri },
  });
};
